var map = {
	"./1/arked.png": 3736,
	"./1/arked1.png": 3640,
	"./1/arked2.png": 1095,
	"./1/arked3.jpg": 3003,
	"./1/arked3.png": 552,
	"./1/arkedlogo.png": 293,
	"./1/home-video-low.mp4": 9220,
	"./2/szoszak1.jpg": 8507,
	"./2/szoszak2.jpg": 1022,
	"./2/szoszak3.jpg": 2640,
	"./2/szoszak4.jpg": 1593,
	"./2/szoszak5.jpg": 7856,
	"./3/kombucha1.png": 8866,
	"./3/logo.bmp": 4743,
	"./data": 6351,
	"./data.json": 6351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6428;